import Alt from 'alt';
import chromeDebug from 'alt-utils/lib/chromeDebug';

/**
 * Setup alt and wrap it in debugger.
 *
 * Requires this chrome extension:
 * https://github.com/goatslacker/alt-devtool
 */

const alt = new Alt();
chromeDebug(alt);

export default alt;



/** WEBPACK FOOTER **
 ** ./app/scripts/alt.js
 **/